module.exports = __webpack_public_path__ + "img/ico-deconnexion.231c33fd.svg";